import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import {
    base64ToFile,
    ImageCroppedEvent,
    ImageCropperComponent,
} from 'ngx-image-cropper';
import { ToastMessageService } from '../../../../services/toast-message.service';

@Component({
    selector: 'app-container-image-upload',
    templateUrl: './container-image-upload.component.html',
    styleUrls: ['./container-image-upload.component.scss'],
    standalone: false,
})
export class ContainerImageUploadComponent {
    @Input() currentImage: string;

    @Output() $imageToUpload: EventEmitter<File> = new EventEmitter();
    @Output() $imageToDelete: EventEmitter<void> = new EventEmitter();

    @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;

    allowedImageTypes: string[] = ['image/jpeg', 'image/jpg'];
    maxImageSize: number = 10 * 1024 * 1024;

    imageChangedEvent: any = '';
    croppedImage: Blob;
    deleteButtonHover: boolean = false;

    constructor(private toastMessageService: ToastMessageService) {}

    cropImage() {
        this.imageCropper.crop();
    }

    discardCrop() {
        this.imageChangedEvent = null;
    }

    deleteImage() {
        this.$imageToDelete.emit();
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.checkFileConstraints(input.files[0]);
        }
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
            this.checkFileConstraints(event.dataTransfer.files[0]);
        }
    }

    allowDrop(event: DragEvent): void {
        event.preventDefault();
    }

    checkFileConstraints(file: File): void {
        if (
            !this.allowedImageTypes.includes(file.type) ||
            file.size > this.maxImageSize
        ) {
            this.toastMessageService.showTranslatedErrorMsg(
                'containerImageUpload.droppedImageError',
                null
            );
            return;
        }

        this.imageChangedEvent = {
            target: {
                files: [file],
            },
        };
    }

    imageCropped(event: ImageCroppedEvent) {
        this.imageChangedEvent = null;
        const croppedImage = event.base64 ?? '';
        this.croppedImage = base64ToFile(croppedImage);
        const file = <File>this.croppedImage;
        this.$imageToUpload.emit(file);
    }
}
